import React from "react";
import { HomeAPI } from "../../blocks/home-api";
import { HomeInfo } from "../../blocks/home-info";
import { HomeApplication } from "../../blocks/home-application";
import { HomeBanner } from "../../blocks/home-banner";
import { HomeCertification } from "../../blocks/home-certification";
import { HomeComment } from "../../blocks/home-comment";
import { HomeConnection } from "../../blocks/home-connection";
import { HomeCustomer } from "../../blocks/home-customer";
import { HomeIdentityInfrastructure } from "../../blocks/home-identity-infrastructure";
import { HomeManagement } from "../../blocks/home-management";
import { HomeTryOn } from "../../blocks/home-try-on";
import { MainNews } from "../../blocks/main-news";
import { Footer } from "../../components/Footer";
import { Header } from "../../components/Header";
import "./styles.less";

export const HomePage = () => {
  return (
    <div className="home-page">
      <Header mode="dark" />
      <HomeBanner />
      <HomeCustomer />
      <HomeManagement />
      <HomeAPI />

      <HomeIdentityInfrastructure />
      <HomeApplication />
      <HomeConnection />
      <MainNews />
      <HomeComment />
      <HomeTryOn />
      <HomeCertification />
      <Footer />
    </div>
  );
};
